/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import Layout from "../../../Layouts/Layout";
import { Helmet } from "react-helmet-async";

import GuidebookHomeSection from "../../../../components/Sections/Generic/GuidebookHomeSection/GuidebookHomeSection";
import { gaSet } from "../../../../services/googleAnalyticsService";

const GenericGuidebookPage = () => {
  const title = "Ratgeber | Legalbird";
  gaSet({ title: title });

  return (
    <Layout backgroundType={"serviceworld"}>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <GuidebookHomeSection />
    </Layout>
  );
};

export default GenericGuidebookPage;
